$(document).ready(function () {
    $("input[name='accept-guidelines']").change(function(){
        $(this).parent().next('.download-list').find('.download-list__link ').toggleClass('disabled');
    })

    $(".download-list__link").on('click', function(e){
        if ( $( this ).hasClass( "disabled" ) ) {
            e.preventDefault();
        }
    })
});